<template>
  <div class="car-archive">
    <div class="search-warehouse">
      <div class="screen">
        <el-input class="white w200" v-model="search.batchNo" placeholder="请输入批次号"></el-input>
        <el-select class="white w200" clearable v-model="search.brandId" placeholder="请选择品牌" filterable 
            v-lazy-load-dropdown="handleScrollDropdown">
          <el-option
            v-for="item in brandTypeOptionsList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          class="white w200"
          v-model="search.arrivalDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
        <el-button class="btn-blue" @click="onSearch">搜索</el-button>
      </div>
      <div class="operation-btn">
        <el-button class="btn-white" @click="addBatch('add')"
          >新增批次号</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="batchList" style="width: 100%">
        <el-table-column 
          v-for="(item, index) in tableTitleList"
          :key="index"
          :label="item.label"
          :prop="item.prop"
          :min-width="item.width"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button class="btn-text" type="text" @click="mod(scope.row)">编辑</el-button>
            <el-button class="btn-text" type="text" @click="lookDetails(scope.row)">详情</el-button>
            <el-button class="btn-text" type="text" @click="openDown(scope.row)">导入</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <pagination-tpl
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @queryChange="queryChange"
      ></pagination-tpl>
    </div>

    
    <!-- 新增/编辑 -->
    <el-dialog :title="type ==='add'?'新增批次号':'编辑'" top="18vh" :visible.sync="promptingDialog" width="420px" :before-close="closeOrderDown">
      <div class="border"></div>
      <el-form
        class="batch-form"
        :rules="batchFormRules"
        ref="batchForm"
        :model="batchForm"
      >
        <el-form-item label="批次号" prop="batchNo">
          <el-input class="white" v-model="batchForm.batchNo" placeholder="请输入批次号"></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brandId">
          <el-select class="white" clearable v-model="batchForm.brandId" placeholder="请选择品牌" filterable
          v-lazy-load-dropdown="handleScrollDropdown">
            <el-option
              v-for="item in brandTypeOptionsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="作业类型" prop="jobType">
          <el-select class="white"
            v-model="batchForm.jobType" placeholder="作业类型">
            <el-option v-for="item in assignmentTypeList" :key="item.id" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到港时间" prop="arrivalDate">
          <el-date-picker
            class="white w200"
            v-model="batchForm.arrivalDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="采集模板" prop="templateId">
          <el-select class="white" clearable v-model="batchForm.templateId" placeholder="请选择采集模板" filterable
          v-lazy-load-dropdown="handleCollectionTemplateScrollDropdown">
            <el-option
              v-for="item in collectionTemplateTypeOptionsList"
              :disabled="item.status === 0"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeOrderDown"
          >取消</el-button
        >
        <el-button class="btn-blue" @click="confirmOrderDown('batchForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 导入车架号VIN -->
    <el-dialog class="down-vin-dialog" title="VIN导入" top="20vh" :visible.sync="downDialog" width="420px" :before-close="closeDown">
      <div class="border"></div>
      <div class="down-tmp">
        <div class="sub-title">
          <span>下载导入模板</span>
          <span class="sub-tips">(点击下载)</span>
        </div>
        <el-button type="text" class="btn-text" @click="downTmp">VIN导入模板.xlsx</el-button>
      </div>
      <div>
        <p class="sub-title">VIN导入</p>
        <el-upload
          v-if="isUpload"
          v-loading.fullscreen.lock="loading3"
          element-loading-text="文件上传中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          class="upload"
          ref="upload"
          action="#"
          :show-file-list="false"
          :auto-upload="true"
          :before-upload="(file) => uploadExcel(file)"
        >
          <el-button slot="trigger" type="text" class="btn-text"
            >{{uploadTipsName}}</el-button
          >
        </el-upload>
        <div v-else class="upload-tips-container">
          <div class="upload-tips-name">
            {{uploadTipsName}}
            <i class="el-icon-error" @click="removeUploadOrder"></i>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDown"
          >取消</el-button
        >
        <el-button class="btn-blue" @click="confirmDown"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { modifyNetTitle, downLoadFile } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import BrandMixins from "common/mixins/smart-vehicle-inspection/brand";
import CollectionTemplateMixins from "common/mixins/smart-vehicle-inspection/collection-template";
import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {
  mixins: [BrandMixins, CollectionTemplateMixins],
  data() {
    return {
      search: {
        batchNo: '',
        brandId: '',
        arrivalDate: ''
      },
      batchList: [],
      tableTitleList: [
        {label: '批次号', prop: 'batchNo', width: '120'},
        {label: '品牌', prop: 'brandName'},
        {label: '采集模板', prop: 'templateName'},
        {label: '计划采集车辆', prop: 'planCount'},
        {label: '应已采集', prop: 'collectedCount'},
        {label: '到港时间', prop: 'arrivalDate'},
        {label: '作业类型', prop: 'assignmentTypeVal'}
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      assignmentTypeList: [
        {id:1, name: '接收检验'}
        // {id:2, name: '移交检验'}
      ],
      
      promptingDialog: false,
      batchForm: {
        id: '',
        batchNo: "",
        brandId: "",
        jobType: 1,
        arrivalDate: "",
        templateId: ""
      },
      batchFormRules: {
        batchNo: [
          { required: true, message: "请输入批次号", trigger: "blur" },
        ],
        brandId: [
          { required: true, message: "请选择品牌", trigger: "change" },
        ],
        jobType: [
          { required: true, message: "请选择作业类型", trigger: "change" },
        ],
        templateId: [
          { required: true, message: "请选择采集模板", trigger: "change" },
        ],
      },
      type: '',
      
      batchId: null,
      loading3: false,
      downDialog: false,
      uploadTipsName: '点击导入',
      /* 订单导入的流 */
      formData: null,
      /* 是否导入 */
      isUpload: true,
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    modifyNetTitle('批次管理')
    this.initBatchList();
    this.initBrandList();
    this.initCollectionTemplateList();
  },
  methods: { 
    initBatchList() {
      let data = this.search
      data.pageNo = this.currentPage
      data.pageSize = this.pageSize
      SmartVehicleInspection.getBatchList(data).then(res => {
        if (res.success) {
          const { records, total, size } = res.result
          this.pageSize = size;
          this.total = total;
          let arr = [];
          records.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.batchNo = value.batchNo;
            obj.brandId = value.brandId;
            obj.brandName = value.brandName;
            obj.templateName = value.templateName;
            obj.planCount = value.planCount;
            obj.collectedCount = value.collectedCount;
            obj.arrivalDate = value.arrivalDate;
            obj.jobType = value.jobType;
            obj.assignmentTypeVal = value.jobType === 1?'接收检验':'移交检验';
            arr.push(obj);
          });
          this.batchList = arr;
        }
      })
    },

    //翻页
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initBatchList();
    },

    onSearch() {
      this.initBatchList()
    },

    lookDetails(row) {
      this.$router.push({
        path: '/vehicle/homework-center/batch/batch-details',
        query: {
          id: row.id,
        }
      })
    },

    mod(row) {
      this.type = 'mod'
      const { id, batchNo, brandId, jobType, arrivalDate, templateId } = row
      this.batchForm.id = id
      this.batchForm.batchNo = batchNo
      this.batchForm.brandId = brandId
      this.batchForm.jobType = jobType
      this.batchForm.arrivalDate = arrivalDate
      this.batchForm.templateId = templateId
      this.promptingDialog = true
    },
    
    closeOrderDown() {
      this.batchForm = {
        id: '',
        batchNo: "",
        brandId: "",
        templateId: "",
        jobType: 1,
        arrivalDate: ""
      }
      this.$nextTick(() => {
        this.$refs.batchForm.clearValidate();
      });
      this.promptingDialog = false
    },
    confirmOrderDown(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.batchForm.id,
            batchNo: this.batchForm.batchNo,
            brandId: this.batchForm.brandId,
            templateId: this.batchForm.templateId,
            jobType: this.batchForm.jobType,
            arrivalDate: this.batchForm.arrivalDate,
          }
          if (this.type === 'mod') {
            SmartVehicleInspection
              .postModBatch(data)
              .then(res => {
                if (res.success) {
                  this.initBatchList()
                  this.closeOrderDown()
                } else {
                  this.$message.error(res.message);
                }
              })
          } else {
            SmartVehicleInspection
              .postAddBatch(data)
              .then(res => {
                if (res.success) {
                  this.initBatchList()
                  this.closeOrderDown()
                } else {
                  this.$message.error(res.message);
                }
              })
          }
        } else {
          console.log("error submit!!");
        }
      });
    },
    addBatch(type) {
      this.type = type
      this.promptingDialog = true
    },

    
    openDown(row) {
      this.batchId = row.id
      this.downDialog = true
    },
    downTmp() {
      let url = 'https://zwy-vehicle-inspect.oss-cn-hangzhou.aliyuncs.com/zc/vehicle-inspect/import_vin_file_template.xlsx'
      downLoadFile('VIN导入模板',url)
    },
    closeDown() {
      this.removeUploadOrder()
      this.downDialog = false
    },
    confirmDown() {
      if (this.isUpload) {
        return this.$message.error("请导入文件");
      }
      SmartVehicleInspection
        .postUploadBatchExcel(this.batchId, this.formData)
        .then(res => {
          if (res.success) {
            const { failRows } = res.result
            if (failRows.length === 0) {
              this.$message.success("导入成功");
              this.initBatchList();
              this.closeDown()
            } else {
              const h = this.$createElement
              const newDatas = []
              failRows.map(item => {
                newDatas.push(h('p', null, `车架号：${item.vin}，失败原因：${item.reason}；`));
              })
              this.$confirm("提示", {
                message: h('div', null, newDatas),
                showCancelButton: false,
                confirmButtonText: "确定",
                customClass: "message-fail-vin",
              }).then(() => {});
            }
          } else {
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(() => {
          this.$message.error("导入失败");
        });
    },
    removeUploadOrder() {
      this.formData = null
      this.batchId = null
      this.uploadTipsName = '点击导入'
      this.isUpload = true
    },
    //导入Excel表格
    uploadExcel(file) {
      var formData = new FormData();
      formData.append("file", file);
      formData.append("id", this.batchId);
      this.formData = formData
      this.uploadTipsName = file.name
      this.isUpload = false
      return false;
    },
    openExcel() {
      this.downDialog = true
    }
  }
};
</script>
<style lang="scss" scoped>
.car-archive {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .search-warehouse {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .screen {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .w200 {
        width: 200px;
        margin-right: 16px;
      }
    }
  }
  .table .el-table ::v-deep.el-table__body-wrapper .el-table__body tr td .cell, 
  .table .el-table ::v-deep.el-table__fixed-body-wrapper .el-table__body tr td .cell {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .el-button--text {
    margin-left: 10px;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
  }
  .el-form {
    margin-bottom: 20px;
    .el-form-item {
      .el-form-item__label {
        line-height: 20px;
      }
      .el-form-item__content {
        width: 100%;
        .el-date-editor,
        .el-radio-group,
        .el-select {
          width: 100%;
        }
      }
    }
  }
  .dialog-footer {
    margin-top: 16px;
    border-top: 1px solid #f7f7f7;
    padding-top: 16px;
    display: flex;
    justify-content: center;
    .btn-white {
      margin-right: 20px;
    }
  }
}
</style>
<style lang="scss">
.down-vin-dialog {
  .down-tmp {
    margin-bottom: 8px;
    .el-button--text {
      margin-left: 0px;
    }
  }
  .sub-title {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }
  .tips {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    margin: 11px 0px 21px 0px;
  }
  .upload-tips-container {
    position: relative;
    width: 180px;
    .upload-tips-name {
      height: 30px;
      line-height: 30px;
      margin: 12px 0px;
      color: #2E68EA;
      background: #EBEEF5;
      border-radius: 2px;
      padding-left: 7px;
      box-sizing: border-box;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      .el-icon-error {
        position: absolute;
        top: -5px;
        right: -8px;
        color: #999999;
        cursor: pointer;
      }
    }
  }
  .el-upload {
    .el-button--text {
      margin-left: 0px;
    }
  }
  .sub-tips {
    color: #999999;
  }
  .dialog-footer {
    margin-top: 16px;
    border-top: 1px solid #f7f7f7;
    padding-top: 16px;
    display: flex;
    justify-content: center;
    .btn-white {
      margin-right: 20px;
    }
  }
}
.message-fail-vin {
  width: 500px;
  .el-message-box__content {
    height: 200px;
    overflow-y: auto;
  }
}
</style>

